package org.example.project.engineservice.cr

import kotlinx.serialization.Serializable

@Serializable
data class CrPreviewLayout(
    val eigeneDatenZeile: String = "",
    val empfaengerFirmenname: String = "",
    val empfaengerStrasseHausnummer: String = "",
    val empfaengerPlzOrt: String = "",
    val firmenIdText: String = "",
    val absenderFirmenName: String = "",
    val absenderStrasseHausnummer: String = "",
    val absenderPlzOrt: String = "",
    val absenderDatum: String = "",
    val betreffText: String = "",
    val briefText: String = "",
    val ortDatumText: String = "",
    val grussformelText: String = "",
    val signaturBildSrc: String = "",
    val signaturNameText: String = "",
    val logoSrc: String = "",
    val footerLines: List<String> = emptyList()
)
